import { Button, TextField, Zoom } from '@mui/material';
import React, { Component, Fragment, useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
// import generatePDF, { Resolution, Margin, usePDF } from 'react-to-pdf';
import generatePDF,{ Resolution, Margin, usePDF } from '../../../node_modules/react-to-pdf/dist/main'
import { HeaderMenu } from '../../component/HeaderMenu';
import { useLocation } from 'react-router-dom';
import { GetSubTasks } from '../../api/GetSubTasks.api';//ok
import LoginContext from '../../context/login_context/LoginContext';

/** ICONS */
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import { ModalLoaded } from '../../component/ModalLoaded.component';
import fileimagen from '../../assets/avatar.png';

const options = {

  // default is `save`
  method: 'open',//download
  // default is Resolution.MEDIUM = 3, which should be enough, higher values
  // increases the image quality but also the size of the PDF, so be careful
  // using values higher than 10 when having multiple pages generated, it
  // might cause the page to crash or hang.
  resolution: Resolution.LOW,
  page: {
    // margin is in MM, default is Margin.NONE = 0
    margin: Margin.MEDIUM,
    // default is 'A4'
    format: 'letter',
    // default is 'portrait','landscape'
    //orientation: 'portrait',
  },
  canvas: {
    // default is 'image/jpeg' for better size performance
    mimeType: 'image/png',
    qualityRatio: 1,
    height:500
  },
  // Customize any value passed to the jsPDF instance and html2canvas
  // function. You probably will not need this and things can break, 
  // so use with caution.
  pagebreak:{ mode: ['css', 'legacy'] },
  overrides: {
    // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
    pdf: {
        compress: true,

    },
    // see https://html2canvas.hertzen.com/configuration for more options
    canvas: {
        useCORS: true,
        pagebreak:    { mode: ['css', 'legacy'] }
    },
  },
};

// you can use a function to return the target element besides using React refs
const getTargetElement = () => document.getElementById('content-id');

export const SiNo_ = ({value}) => {
  // console.log(value);
  switch (value) {
    case 'true':
      return <span><CheckBoxIcon/>Si<CheckBoxOutlineBlankIcon/>No<CheckBoxOutlineBlankIcon/>N/A</span>
    case 'false':
      return <span><CheckBoxOutlineBlankIcon/>Si<CheckBoxIcon/>No<CheckBoxOutlineBlankIcon/>N/A</span>
    case 'N/A':
      return <span><CheckBoxOutlineBlankIcon/>Si<CheckBoxOutlineBlankIcon/>No<CheckBoxIcon/>N/A</span>
    case null:
      return <span><CheckBoxOutlineBlankIcon/>Si<CheckBoxOutlineBlankIcon/>No<CheckBoxOutlineBlankIcon/>N/A</span>
  }
}

export const AproboAlertaFallo_ = ({value}) => {
  // console.log(value);
  switch (value) {
    case '1':
      return <span><CheckBoxIcon/>Aprobó<CheckBoxOutlineBlankIcon/>Alerta<CheckBoxOutlineBlankIcon/>Falló</span>
    case '2':
      return <span><CheckBoxOutlineBlankIcon/>Aprobó<CheckBoxIcon/>Alerta<CheckBoxOutlineBlankIcon/>Falló</span>
    case '3':
      return <span><CheckBoxOutlineBlankIcon/>Aprobó<CheckBoxOutlineBlankIcon/>Alerta<CheckBoxIcon/>Falló</span>
    case null:
      return <span><CheckBoxOutlineBlankIcon/>Aprobó<CheckBoxOutlineBlankIcon/>Alerta<CheckBoxOutlineBlankIcon/>Falló</span>
  }
}

export const OtPdf_big = ({TASK,OT,ModalLoadded,setModalLoadded}) => {


  const {LoginState} = useContext(LoginContext);

	const [ModalLoadded_, setModalLoadded_] = useState(false);
  const [Texto, setTexto] = useState('');

  const [SubTaskBault, setSubTaskBault] = useState([])

  //**************************************************************************************************** */
  

  const insertIdsEvery900px = async () => {
    const container = document.getElementById("content-id");
    const allElements = container.querySelectorAll("*"); // o ajusta según tus hijos relevantes
    const interval = 1210;//1190
    const totalHeight = container.scrollHeight;
    let currentY = interval;
    let sectionCount = 1;

    let arrId_2 = ["imagen-cotrol"]
    let arrId = []

    while (currentY < totalHeight) {
      // Encuentra el primer elemento cuyo offsetTop esté cerca de currentY
      for (let el of allElements) {
        const elTop = el.offsetTop;
        if (Math.abs(elTop - currentY) < 50 && !el.id) {
          // el.id = `seccion-${sectionCount}`;
          el.id = `separadorCTM-${sectionCount}`;
          arrId.push( `separadorCTM-${sectionCount}`)
          arrId_2.push( `separadorCTM-${sectionCount}`)
          sectionCount++;
          break;
        }
      }
      currentY += interval-50;
    }
    arrId_2.push("finOT_control")
    // console.log(arrId_2)
    arrId.forEach(id_ => {
      const target = document.getElementById(id_);
      if (target) {
        const nuevoDiv = document.createElement("div");
        nuevoDiv.innerText = OT;
        nuevoDiv.className = "col-12";
        nuevoDiv.style.background = "#cce";
        nuevoDiv.style.padding = "10px";
        nuevoDiv.style.breakBefore = "page";
        nuevoDiv.style.pageBreakAfter = "always";
        target.parentNode.insertBefore(nuevoDiv, target);
      }
    });

    let htmConjunto = ""
    const handleLoad = async (id_1, id_2) => {
      const startElement = document.getElementById(id_1);
      const endElement = document.getElementById(id_2);
      
      if (startElement && endElement) {
        let htmlContent = '';
        let currentElement = startElement;

        // Recorre todos los nodos entre 'inicio' y 'fin'
        while (currentElement && currentElement !== endElement.nextSibling) {
          htmlContent += currentElement.outerHTML;
          currentElement = currentElement.nextElementSibling;
        }
// une el codigo html atravaz de un div para la paginacion
        htmConjunto += `<div className="container-fluid" style="breakBefore:page,pageBreakAfter=always">
        <div className="row">${htmlContent}</div></div>`;
        
      }

    };
    
    for (let i = 0; i < arrId_2.length; i++) {
      if(arrId_2[i] === "finOT_control") continue;
      else{
        handleLoad(arrId_2[i], arrId_2[i+1]);
      }
    }
  };

  const contentRef = useRef();
  const [pdfUrl, setPdfUrl] = useState(null);


  //**************************************************************************************************** */

  const state = {TASK,OT}
  // console.log({TASK,OT})
  const ObtainSubTasks = async () => {
    setTexto(`Estamos Obteniendo las subtareas, que son ${state.TASK.length}`)
    setModalLoadded_(true)
    let bault = []
    for (let tsk = 0; tsk < state.TASK.length; tsk++) {
      const tsk_ = state.TASK[tsk];
      // console.log(state)
      let SubTaskData = await GetSubTasks({subtask_id:tsk_.id_work_orders_tasks,planta:LoginState.planta})
      setTexto(`Estamos Obteniendo las subtareas, que son ${tsk+1}/${state.TASK.length}`)
      // console.log(SubTaskData)
      bault.push(SubTaskData);
    }
    // console.log(bault);
    await setSubTaskBault(bault)
    await setTimeout(async() => {
      await insertIdsEvery900px()      
      await setModalLoadded_(false)
    }, 3000);
  }
  useEffect(() => {
    ObtainSubTasks()
  }, [])

  function segundosAHorasMinutos(segundos) {
		const horas = Math.floor(segundos / 3600);       // Calcula las horas
		const minutos = Math.floor((segundos % 3600) / 60); // Calcula los minutos restantes
		
		// Formatea a 2 dígitos (ej: 5 → "05")
		const horasStr = horas.toString().padStart(2, '0');
		const minutosStr = minutos.toString().padStart(2, '0');
		
		return `${horasStr}:${minutosStr}`; // Devuelve "hh:mm"
	}

  function traduceUgencia(urgencia) {
    // console.log(urgencia)
    switch (urgencia) {
      case 'VERYHIGH':
        return 'MUY ALTA';

      case 'HIGH':
        return 'ALTA';

      case 'MEDIUM':
        return 'MEDIA';
      
      case 'LOW':
        return 'BAJA';

      case 'VERYLOW':
        return 'MUY BAJA';
      
      default:
        return 'MEDIA.';
    }
  }

  function traduceActivador(activador) {
    let tapp = activador.split("$")
    // console.log(tapp)
    let arrfRACE = []

    if(activador === "NO_SCHEDULE_TASK"){
      return  "SIN TAREA PROGRAMADA"
    }else{
      for (let tra = 0; tra < tapp.length; tra++) {
        const tra_ = tapp[tra];
        switch (tra_) {
          case 'DATE':
            arrfRACE.push('');
            break
    
          case 'EVERY':
            arrfRACE.push('Cada');
            break
  
          case 'DAYS':
            arrfRACE.push('Dia(as)');
            break
    
          case 'WEEKS':
            arrfRACE.push('Semana');
            break
          
          case 'MONTHS':
            arrfRACE.push('Mes(es)');
            break
  
          case 'YEARS':
            arrfRACE.push('Año(s)');
            break
          
          case 'MONDAY':
            arrfRACE.push('Lunes');
            break

          case 'TUESDAY':
            arrfRACE.push('Martes');
            break

          case 'WEDNESDAY':
            arrfRACE.push('Miércoles');
            break

          case 'THURSDAY':
            arrfRACE.push('Jueves');
            break

          case 'FRIDAY':
            arrfRACE.push('Viernes');
            break

          case 'SATURDAY':
            arrfRACE.push('Sábado');
            break

          case 'SUNDAY':
            arrfRACE.push('Domingo');
            break

          case 'EVENT':
            arrfRACE.push('');
            break

          default:
            arrfRACE.push(`${tra_}`);
            break
        }
      }
      return arrfRACE.join(' ')
    }
  }
  
  return (
    <>
      {/* incia el PDF */}
      <div ref={contentRef} style={{width:900, paddingLeft:15, paddingRight:15, marginLeft: 'auto', marginRight: 'auto'}} id="content-id">
        <div className='row'>
          <div className='col-12' id='imagen-cotrol'>
            <div className='row'>
              <div className='col-3'>
                <img src={require("../../assets/logoariztia.png")} />
              </div>
              <div className='col-6 pt-3 text-center'>
                <span><b>EMPRESA ARIZTIA</b></span><br/><br/>
                <span className='mt-3'>Orden de Trabajo</span>
              </div>
              <div className='col-3 pt-3'>
                <span><b>N°: {state.OT}</b></span><br/>
                <span>Fecha: <b className='text-danger'>{TASK[0].creation_date.split('T')[0]}</b></span><br/>
                <span>Calificación:</span>
              </div>
            </div>
          </div>
          {/*  */}
          <div className='col-12 pdf-borde'>
            <div className='row'>
              <div className='col-6'>
                <span><b>GENERÓ:</b> {state.TASK[0].created_by}</span><br/>
                <span><b>DURACIÓN ESTIMADA:</b> 
                                {segundosAHorasMinutos(state.TASK[0].duration)}
                                </span>
              </div>
              <div className='col-6'>
                <span><b>RESPONSABLE:</b> {state.TASK[0].user_assigned}</span><br/>
                <span><b>NOTAS:</b> {state.TASK[0].note}</span>
              </div>
            </div>
          </div>

          {/*  */}
          <div className='col-12 pdf-borde mt-3'>
          </div>

          {/*  */}
          <div className='col-12 mt-2'>
            <div className='row'>
              <div className='col-12'>
              <h5><u>ACTIVOS</u></h5>
              </div>
              <div className='col-6'>
                <span><b>DESCRIPCIÓN:</b> {state.TASK[0].items_log_description}</span><br/>
                <span><b>UBICADO EN O ES PARTE DE:</b> {state.TASK[0].parent_description}</span><br/>
                <span><b>TIPO:</b> {state.TASK[0].groups_description}</span><br/>
                <span><b>PRIORIDAD:</b> {traduceUgencia(state.TASK[0].priorities_description)}</span><br/>
              </div>
              <div className='col-6'>
                <span><b>CLASIFICACIÓN 1:</b> {state.TASK[0].groups_1_description}</span><br/>
                <span><b>CLASIFICACIÓN 2:</b> {state.TASK[0].groups_2_description}</span><br/>
                <span><b>CENTRO DE COSTO:</b> {state.TASK[0].costs_center_description}</span><br/>
              </div>
            </div>
          </div>

          {
            state.TASK.map((task,index)=><Fragment key={task.id_work_orders_tasks}>
              {/* {console.log(task.description) } */}
              <div className='col-12 mt-3'>
                <h5><u>TAREA NO PLANIFICADA</u></h5>
              </div>
              {/* <div className='col-12 pdf-borde'> */}
                {/* <div className='row'> */}
                  <div className='col-6'>
                    <span><b>DESCRIPCIÓN:</b> {task.description}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>CLASIFICACIÓN 1:</b> {task.tasks_log_types_description}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>FECHA PROGRAMADA:</b> {task.date_maintenance.split('T')[0]}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>CLASIFICACIÓN 2:</b> {task.tasks_log_types_2_description}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>TIPO DE MANTENIMIENTO:</b>{task.tasks_log_task_type_main}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>ACTIVADOR:</b>{traduceActivador(task.trigger_description)}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>FECHA DEL EVENTO:</b> {task.event_date&&new Date(task.event_date).toLocaleString()}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>SOLICITADA POR:</b> {task.requested_by}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>DURACIÓN ESTIMADA:</b> {segundosAHorasMinutos(task.tasks_duration)}</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>HORA FIN:</b> _______________________________________________</span><br/>
                  </div>
                  <div className='col-6'>
                    <span><b>HORA INICIO:</b> ___________________________________________</span><br/>
                  </div>
                {/* </div> */}
              {/* </div> */}
              
             <div className='col-12 pdf-borde-c text-center'>
                <h3>SUBTAREAS</h3>
              </div>
              <div className='col-4 pdf-borde-c'><span><b>Grupo/Parte</b></span></div>
              <div className='col-4 pdf-borde-c'><span><b>Procedimiento</b></span></div>
              <div className='col-4 pdf-borde-c'><span><b>Resultado</b></span></div>
              
               {SubTaskBault.length>0?SubTaskBault[index].map(stfr=>
                  <div key={stfr.id_work_orders_tasks_form_items+0} className='col-12'>
                    <div className='row'>
                      <div key={stfr.id_work_orders_tasks_form_items+1} className='col-4 pdf-borde-c' style={{display: 'flex', alignContent: 'center', alignItems: 'center'}}><small>{stfr.group}</small></div>
                      <div key={stfr.id_work_orders_tasks_form_items+2} className='col-4 pdf-borde-c' style={{display: 'flex', alignContent: 'center', alignItems: 'center'}}><small>{stfr.description}</small></div>
                      <div key={stfr.id_work_orders_tasks_form_items+3} className='col-4 pdf-borde-c' style={{display: 'flex', alignContent: 'center', alignItems: 'center'}}>
                        <small>{
                          stfr.id_task_form_item_type===1?stfr.value:
                          stfr.id_task_form_item_type===3?stfr.value:
                          stfr.id_task_form_item_type===2?<SiNo_ value={stfr.value}/>:
                          stfr.id_task_form_item_type===4?<AproboAlertaFallo_ value={stfr.value}/>:null
                        }</small></div>
                    </div>
                  </div>
                ): null}
             
            </Fragment>)
          }
                <div className='col-12' id='finOT_control'><span><b>FIN OT</b></span></div>

        </div>
      </div>
      {/* fin ot */}
      <div className='container'>
        <div className='row' >
          <div className='col-9'>
          </div>
          <div className='col-3 text-right'>
            <button type="button" className="btn btn-danger" onClick={() => setModalLoadded(!ModalLoadded)}><CloseIcon/></button>
            <button className='ml-2 btn btn-success' onClick={() => generatePDF(getTargetElement, options)}>Imprimir PDF</button>
            {/* <button onClick={()=>GenerarPDF_NOW()}>Generar PDF</button> */}
          </div>
        </div>
      </div>
      {/* Mostrar el PDF generado */}
      {/* {pdfUrl && (
        <iframe
          src={pdfUrl}
          title="Visor PDF"
          style={{
            width: "100%",
            height: "600px",
            border: "1px solid #ccc",
            marginTop: "20px",
          }}
        />
      )} */}
      {
				 ModalLoadded_?<ModalLoaded texto={Texto} />:null
			}
      {/* BORRAR */}
      <br/>
      <br/>
      <br/>
      <br/>
    </>
  )
}
